import { Container, Row, Col } from 'react-bootstrap';
import logo2 from '../assets/images/logo2.png';
import { FaInstagram, FaFacebookF, FaWhatsapp} from 'react-icons/fa'; // Impor ikon 

const Footer = () => {
    return (
        <footer className="footer-bg text-white pt-5 pb-4">
            <Container>
                <Row>
                    {/* Kolom 1: Logo dan Deskripsi */}
                    <Col md={4} lg={4} className="mb-4">
                        <img src={logo2} alt="Logo" className="footer-logo mb-3" />
                        <p>
                            Syailendra Auction adalah balai lelang numismatik terkemuka di Indonesia.
                        </p>
                        <div className="social-icons mt-3">
                            <a href="https://www.instagram.com/yulianto.e?utm_source=ig_web_button_share_sheet&igsh=MTdoM283MTBjNDVubw==" className="social-icon-link me-3"><FaInstagram /></a>
                            <a href="https://www.facebook.com/yeko123?locale=id_ID" className="social-icon-link me-3"><FaFacebookF /></a>
                            <a href="https://api.whatsapp.com/send/?phone=6281233940758&text&type=phone_number&app_absent=0" className="social-icon-link"><FaWhatsapp /></a>
                        </div>
                    </Col>

                    {/* Kolom 2: Quick Links */}
                    <Col md={4} lg={4} className="mb-4">
                        <h5 className="text-uppercase fw-bold mb-4">Quick Links</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2"><a href="/auction" className="footer-link">Auction</a></li>
                            <li className="mb-2"><a href="/selling" className="footer-link">Selling</a></li>
                            <li className="mb-2"><a href="/about" className="footer-link">About Us</a></li>
                            <li className="mb-2"><a href="/terms" className="footer-link">Terms & Conditions</a></li>
                        </ul>
                    </Col>

                    {/* Kolom 3: Kontak */}
                    <Col md={4} lg={4} className="mb-4">
                        <h5 className="text-uppercase fw-bold mb-4">Contact</h5>
                        <p><i className="fas fa-home me-3"></i>Jl. Selat Sunda 2 No. 44, Malang, Indonesia</p>
                        <p><i className="fas fa-envelope me-3"></i>info@syailendra-auction.com</p>
                        <p><i className="fas fa-phone me-3"></i>+6281-2339-40758</p>
                    </Col>
                </Row>
            </Container>
            <div className="text-center p-3 copyright-bg">
                © 2025 Copyright:
                <a className="text-white fw-bold" href="/homepage"> SyailendraAuction.com</a>
            </div>
        </footer>
    );
}

export default Footer;